import React from 'react';
import './SttBanner.scss';
import './SttBannerResponsive.scss';

import sstBan from 'assets/images/common-image/services/stt-banner.jpg';
import sstMob from 'assets/images/common-image/services/stt-mob.png';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SttBanner = () => {
	const industryContent = useSelector((state) => state.content?.industry);
	const industryData = industryContent?.content ? JSON.parse(industryContent?.content) : '';
	console.log('industryData', industryData);

	return (
		<>
			<section
				className="SttBanner"
				style={{ background: `url(${industryData?.banner?.img ? `${process.env.REACT_APP_RESOURCE_URL}/${industryData?.banner?.img}` : sstBan})` }}
			>
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-7 col-md-7 col-sm-7 col-12">
							<div className="SttBannerLeft">
								<h5>Our Industries</h5>
								<h2
									dangerouslySetInnerHTML={{
										__html: industryData?.banner?.heading ?? `Web Development`,
									}}
								></h2>
								<p
									dangerouslySetInnerHTML={{
										__html:
											industryData?.banner?.description ??
											`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum
										suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Quis ipsum suspendisse ultrices gravida. Risus
										commodo viverra maecenas accumsan.`,
									}}
								></p>
								<div class="w-100 callCont">
									<ul class="d-flex flex-wrap align-items-center">
										<li>
											<a href="https://calendly.com/aqualeafitsol/30min" target="_blank" rel="noreferrer">
												Book a Call
											</a>
										</li>
										<li>
											<Link to={`/contact`}>Contact Us</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-lg-5 col-md-5 col-sm-5 col-12">
							<div className="SttBannerRight text-center">
								<img
									src={industryData?.banner?.bannerDisplayImg ? `${process.env.REACT_APP_RESOURCE_URL}/${industryData?.banner?.bannerDisplayImg}` : sstMob}
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default SttBanner;
